import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static get values() {
    return {
      url: String,
      token: String,
    };
  }

  constructor() {
    super(...arguments);
    this.widgetAvailable = false;
  }

  connect() {
    this.initializeSupportWidget();
  }

  async initializeSupportWidget() {
    await this.waitForWidget();
    this.widgetAvailable = true;
  }

  async waitForWidget() {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      if (typeof window.FreshworksWidget === "function") {
        resolve();
      }
    });
  }

  showFresh(event) {
    event.preventDefault();

    if (this.widgetAvailable === true) {
      this.authenticateWidget();
      this.prefillWidgetForm();
      this.showWidget();
    } else {
      window.open(this.urlValue, "_blank");
    }
  }

  prefillWidgetForm() {
    window.FreshworksWidget("prefill", "ticketForm", {
      custom_fields: {
        cf_current_path: window.location.href,
      },
    });

    window.FreshworksWidget("disable", "ticketForm", ["custom_fields.cf_current_path"], {});
    window.FreshworksWidget("hide", "ticketForm", ["custom_fields.cf_current_path"], {});
  }

  authenticateWidget() {
    if (!this.tokenValue || this.tokenValue === "") return;

    window.FreshworksWidget("authenticate", {
      token: this.tokenValue,
      callback: this.authenticateCallback(),
    });
  }

  async authenticateCallback() {
    const response = await get(`${window.location.origin}/freshdesk/token`, {
      responseKind: "json",
    });
    if (response.ok) {
      const body = await response.json;
      window.FreshworksWidget("authenticate", { token: body.freshdesk_widget_auth_token });
    }
  }

  showWidget() {
    try {
      window.FreshworksWidget("open");
    } catch {
      window.rollbar.error("Failed to open Freshworks widget");
      window.open(this.urlValue, "_blank");
    }
  }
}
